// extracted by mini-css-extract-plugin
module.exports = {"page-wipe":"PageWipe_page-wipe__rSjbO","pageWipe":"PageWipe_page-wipe__rSjbO"};